import React from "react";
import styles from "./utilityButton.module.scss";

const UtilityButton = (props) => {
  const { text, subtext, icon, onClick } = props;

  return (
    <React.Fragment>
      <div className={styles.utilityButton} onClick={onClick}>
        <div className={styles.utilityButtonIcon}>
          <img src={icon} alt={""} />
        </div>
        <div className={styles.utilityButtonTextArea}>
          <div className={styles.utilityButtonText}>{text}</div>
          <div className={styles.utilityButtonSubtext}>{subtext}</div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default UtilityButton;
